import React from 'react';
import { Level } from 'rbx';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0rem 1rem;
  padding-bottom: 1rem;
`;

const Footer2 = ({ isSubmitting, onClose, handleSubmit }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Level.Item>
          <a onClick={onClose} className="button is-outlined is-grey">
            <span>Cancel</span>
          </a>
        </Level.Item>
      </Level.Item>

      <Level.Item align="right">
        <Level.Item>
          <button
            type="submit"
            className={`button is-primary ${isSubmitting && 'is-loading'}`}
            onClick={handleSubmit}
          >
            <span>Modify Booking</span>
          </button>
        </Level.Item>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default Footer2;
